import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { mediaQuery, font, color } = baseVariables;

export const StyledImageCard = styled.div`
  width: 100%;
  height: 100%;

  @media ${mediaQuery.md} {
    width: 45%;
  }

  @media ${mediaQuery.lg} {
    width: 30%;
  }

  .card {
    position: relative;
    height: ${toRem(220)};
    border-radius: ${toRem(12)};

    .card-image {
      width: 100%;
      height: 100%;
      border-radius: ${toRem(12)};
      object-fit: cover;
    }

    .remove-card {
      height: ${toRem(32)};
      padding: ${toRem(4)};
      border-radius: ${toRem(4)};
      position: absolute;
      top: ${toRem(8)};
      right: ${toRem(8)};
      &:focus-visible {
        outline: -webkit-focus-ring-color auto ${toRem(1)};
      }
    }
  }
`;

export const StyledImageCardShell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: ${color.neutral20};
  border-radius: ${toRem(12)};
  padding: ${toRem(16)};

  .shell-subtitle {
    font-weight: ${font.fontWeightRegular};
    text-decoration: underline;
  }
`;
